(function () {
  if (window.__g2mNudgeInit) return;
  window.__g2mNudgeInit = true;

  function fmt(cents, cur) {
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }

  function update(total) {
    var sections = document.querySelectorAll('[data-section-type="g2m-shipping-nudge"]');
    for (var i = 0; i < sections.length; i++) {
      var sec = sections[i];
      var threshold = parseInt(sec.getAttribute('data-threshold-cents'), 10) || 0;
      var cur = sec.getAttribute('data-currency') || 'USD';
      var fill = threshold > 0 ? Math.min(100, Math.max(0, total / threshold * 100)) : 0;
      sec.style.setProperty('--g2m-bar-fill', fill.toFixed(1) + '%');
      var track = sec.querySelector('[data-g2m-nudge-track]');
      if (track) track.setAttribute('aria-valuenow', Math.round(fill));
      var curEl = sec.querySelector('[data-g2m-nudge-current]');
      if (curEl) curEl.textContent = fmt(total, cur);
      var goalEl = sec.querySelector('[data-g2m-nudge-goal]');
      if (goalEl) {
        if (total >= threshold) {
          goalEl.textContent = sec.getAttribute('data-qualified-text') || '';
        } else {
          goalEl.textContent = fmt(threshold - total, cur) + ' ' + (sec.getAttribute('data-remaining-suffix') || '');
        }
      }
    }
  }

  var pending = false;
  function refresh() {
    if (pending) return;
    pending = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { pending = false; update(c.total_price); })
      .catch(function () { pending = false; });
  }

  document.addEventListener('product:added', function () { setTimeout(refresh, 350); });
  document.documentElement.addEventListener('cart:rerendered', function () { setTimeout(refresh, 50); }, true);
  var count = document.querySelector('.header__cart-count');
  if (count && window.MutationObserver) {
    new MutationObserver(function () { refresh(); }).observe(count, { childList: true, characterData: true, subtree: true });
  }
  if (document.readyState !== 'loading') refresh();
  else document.addEventListener('DOMContentLoaded', refresh);
})();
